module.exports = __webpack_public_path__ + "reactNative.1uj0ocMQ.png";